"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M16 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v7.817l2.854 2.863a.5.5 0 0 1-.354.853H21v4.515a.5.5 0 1 1-1 0v-5.015a.5.5 0 0 1 .5-.5h1.795l-2.15-2.156A.5.5 0 0 1 20 8.524V1h-3v3.512a.5.5 0 0 1-.854.353l-3.5-3.51a.911.911 0 0 0-1.292 0l-9.65 9.678H3.5a.5.5 0 0 1 .5.5v10.031h12.5a.5.5 0 1 1 0 1h-13a.5.5 0 0 1-.5-.5V12.033H.5a.5.5 0 0 1-.354-.853L10.646.648a1.91 1.91 0 0 1 2.708 0L16 3.302V.5Zm-5.033 8.493c.683-.172 2.323-.586 3.796.892.821.824 1.087 1.83 1.104 2.717a5.47 5.47 0 0 1-.278 1.794l7.283 6.461a.5.5 0 0 1 .143.216l-.474.158.474-.157v.001l.001.002.002.005.005.016a1.942 1.942 0 0 1 .052.213c.027.134.054.323.054.54 0 .432-.108 1.025-.588 1.506-.378.38-.872.563-1.293.621-.213.03-.425.03-.615-.002-.172-.029-.4-.096-.568-.264l-.009-.01-6.72-7.102c-1.023.23-2.758.433-4.23-1.044-.834-.836-1.03-1.872-1.03-2.658a5.087 5.087 0 0 1 .19-1.362l.008-.025.002-.007.001-.003V11.5l.475.157-.474-.158a.5.5 0 0 1 .828-.195l1.866 1.871.943-.472.472-.948-1.868-1.873a.5.5 0 0 1 .256-.843c.051-.01.116-.027.192-.046Zm-1.886 3.701a3.872 3.872 0 0 0-.006.204c0 .632.158 1.37.738 1.952 1.208 1.21 2.636.944 3.565.711a.5.5 0 0 1 .485.142l6.885 7.276a1.076 1.076 0 0 0 .363.009c.262-.037.535-.149.722-.337.227-.228.296-.521.296-.8a1.74 1.74 0 0 0-.035-.345v-.003l-7.426-6.587a.5.5 0 0 1-.128-.57 4.434 4.434 0 0 0 .328-1.725c-.014-.703-.22-1.435-.813-2.03-.763-.765-1.538-.84-2.173-.759l1.467 1.472a.5.5 0 0 1 .093.576l-.707 1.418a.5.5 0 0 1-.223.224l-1.414.71a.5.5 0 0 1-.579-.095l-1.438-1.443Zm12.985 8.694v-.002.002",
    clipRule: "evenodd"
  })]
});